import useClientConfig from "../../../../../config/careers/clientConfig";
import { useDispatch, useSelector } from "react-redux";
import { getJobList } from "../../../../../redux/slices/careersSlices.reducer";
import React, { useEffect, useState } from "react";

const CvmBanner = () => {
    const { clientAssetsLink, clientConfig } = useClientConfig();
    const dispatch = useDispatch();
    
    const filterJobs = (catName: string) => {
        const jobCategories = localStorage.getItem("jobCategories");
        if(jobCategories){
            const parsedData = JSON.parse(jobCategories);
            if(parsedData && parsedData.length > 0){
                const filterItem = parsedData.find((item: any) => item.categoryName.toLowerCase() === catName)?.jobCategoryId || catName;
                if(filterItem){
                    const apiParams: any = {};
                    const obj: any = {};
                    apiParams["categoryId"] = filterItem;
                    obj["url"] = clientConfig?.data?.data?.clientSettings?.clientId;
                    obj["params"] = apiParams;
                    dispatch<any>(getJobList(obj));
                    
                    //scroll down to job list
                    setTimeout(() => {
                        const element = document.getElementsByClassName("mob-job-search-parent")[0];
                        if(element){
                            const yOffset = -100; 
                            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                            window.scrollTo({top: y, behavior: "smooth"});
                        }
                    }, 250);
                }
            }
        }
    };
    return (
        <>
            <div className="topcontent">
                <div id="careers" className="home__careers pt-3 pb-5 pb-sm-6 pt-sm-5">
                    <h2 className="section-heading section-heading--outline careers__heading container">City Careers</h2>
                    <div className="home__banner careers__banner">
                        <img
                            src={clientAssetsLink + "/banner.png"}
                            data-src={clientAssetsLink + "/banner.png"}
                            width="100%" height="auto"
                            className="img-fluid d-none d-md-block lazyloaded"
                            alt="city careers banner"
                            data-srcSet={`${clientAssetsLink + "/banner.png"} 1920w, ${clientAssetsLink + "/banner.png"} 1200w, ${clientAssetsLink + "/banner.png"} 992w, ${clientAssetsLink + "/banner.png"} 768w`}
                            srcSet={`${clientAssetsLink + "/banner.png"} 1920w, ${clientAssetsLink + "/banner.png"} 1200w, ${clientAssetsLink + "/banner.png"} 992w, ${clientAssetsLink + "/banner.png"} 768w`}
                        />
                        <img
                            src={clientAssetsLink + "/banner.png"}
                            data-src={clientAssetsLink + "/banner.png"}
                            width="100%" height="auto"
                            className="img-fluid d-block d-md-none lazyloaded"
                            alt="city careers banner"
                            data-srcSet={`${clientAssetsLink + "/banner.png"} 768w, ${clientAssetsLink + "/banner.png"} 576w, ${clientAssetsLink + "/banner.png"} 375w`}
                            srcSet={`${clientAssetsLink + "/banner.png"} 768w, ${clientAssetsLink + "/banner.png"} 576w, ${clientAssetsLink + "/banner.png"} 375w`}
                        />
                        <div className="container">
                            <h3 className="home-banner__text home-banner-style"><span>Create, Delight and Engage</span></h3>
                        </div>
                    </div>
                    <div className="container">
                        <div className="careers__content content typography no-margin-on-last-p pt-4 pt-sm-5">
                            <p>We only succeed when our people have the resources, support, and encouragement to thrive. So at City Venue Management, we give our people the platform to enjoy a rewarding career, as well as the resources to fulfill their potential.</p>
                            <p>City Venue Management is an equal opportunity employer (EOE). We strive to create an inclusive and diverse workplace that respects our people’s beliefs, orientations, identities, and cultures. We encourage people from all backgrounds to apply for a position within our organisation. Because together, we are City Venue Management.</p>
                            <p>We put a strong emphasis on training and development, helping our people pick up the skills to confidently take on their roles. As part of this, we have developed an Emerging Leaders program — providing a pathway for those looking to further their careers. Our Citypedia conference brings the whole organisation together for a day of learning and development. And our traineeships are designed to nurture young people with potential.</p>
                            <p>It’s a culture that helps us all delight and engage, are you ready to be part of it?</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container main-cntr-v2">
                <div className="landing-img1">
                    <div className="landing-heading">
                        <h2> Find a job</h2>
                    </div>
                    <div className="container">
                        <div className="job-grid">
                            <div className="job-card">
                                <div onClick={() => filterJobs("site support")} className="image-card-link">
                                    <img src={clientAssetsLink + "/site-admin.jpg"} alt="Site Support" />
                                    <h5>Site Support (Head Office)</h5>
                                </div>
                            </div>
                            <div className="job-card">
                                <div onClick={() => filterJobs("swim teaching")} className="image-card-link">
                                    <img src={clientAssetsLink + "/swim-teach.jpg"} alt="Swim Teaching" />
                                    <h5>Swim Teaching</h5>
                                </div>
                            </div>
                            <div className="job-card">
                                <div onClick={() => filterJobs("life guarding")} className="image-card-link">
                                    <img src={clientAssetsLink + "/lifeguarding.jpg"} alt="Lifeguarding" />
                                    <h5>Lifeguarding</h5>
                                </div>
                            </div>
                            <div className="job-card">
                                <div onClick={() => filterJobs("health club")} className="image-card-link">
                                    <img src={clientAssetsLink + "/health-club.jpg"} alt="Health Club" />
                                    <h5>Health Club</h5>
                                </div>
                            </div>
                            <div className="job-card">
                                <div onClick={() => filterJobs("coaching")} className="image-card-link">
                                    <img src={clientAssetsLink + "/coaching.jpg"} alt="Coaching" />
                                    <h5>Coaching</h5>
                                </div>
                            </div>
                            <div className="job-card">
                                <div onClick={() => filterJobs("site management")} className="image-card-link">
                                    <img src={clientAssetsLink + "/site-management.jpg"} alt="Site Management" />
                                    <h5>Site Management</h5>
                                </div>
                            </div>
                            <div className="job-card">
                                <div onClick={() => filterJobs("traineeships")} className="image-card-link">
                                    <img src={clientAssetsLink + "/traineeship.jpg"} alt="Traineeships" />
                                    <h5>Traineeships</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CvmBanner;